import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type NewTaskStore = {
    open: boolean;
    setOpen: (open: boolean, options?: { taskListId: number }) => void;
    options: {
        taskListId: number;
    } | null;
};

type TaskListFetchingStore = {
    fetching: boolean;
    setFetching: (fetching: boolean) => void;
};

export const useNewTaskStore = create<NewTaskStore>((set) => ({
    open: false,
    options: null,
    setOpen: (open: boolean, options?: { taskListId: number }) => set({ open, options: options || null }),
}));

export const useTaskListFetchingStore = create<TaskListFetchingStore>((set) => ({
    fetching: false,
    setFetching: (fetching: boolean) => set({ fetching }),
}));

type LocalSettingsStore = {
    formAttributesCollapsiblePanelOpen: boolean;
    setFormAttributesCollapsiblePanelOpen: (open: boolean) => void;
    sheetWidth: number;
    setSheetWidth: (width: number) => void;
    sidebarWidth: number;
    setSidebarWidth: (width: number) => void;
    inboxSidebarWidth: number;
    setInboxSidebarWidth: (width: number) => void;
};

export const useLocalSettingsStore = create<LocalSettingsStore>()(
    persist(
        (set, _get) => ({
            formAttributesCollapsiblePanelOpen: false,
            setFormAttributesCollapsiblePanelOpen: (open: boolean) => set({ formAttributesCollapsiblePanelOpen: open }),
            sheetWidth: 800,
            sidebarWidth: 270,
            setSheetWidth: (width: number) => set({ sheetWidth: width }),
            setSidebarWidth: (width: number) => set({ sidebarWidth: width }),
            inboxSidebarWidth: 270,
            setInboxSidebarWidth: (width: number) => set({ inboxSidebarWidth: width }),
        }),
        {
            name: "local-settings", // name of the item in the storage (must be unique)
            storage: createJSONStorage(() => localStorage),
        }
    )
);

